var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vehicles"},[_c('page-header',{attrs:{"title":"Fleets","breadcrumb":"Dashboard > Settings  > Fleets"}}),_c('vehicles-data-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }